import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  customTool: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginTop: '10px'
  },
  disableImportLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  inputField: {
    width: '100%'
  },
  dialogModal: {
    '& .MuiPaper-root': {
      '& .makeStyles-dialogTitle-38': {
        padding: '16px 12px !important',
      },
      maxWidth: '490px',
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  disableIcon: {
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  importLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
  },
  invalidRow: {
    backgroundColor: '#ffcccc !important'
  },
  targetContainer: {
    marginBottom: '20px',
    border: '2px solid grey',
    margin: '12px'
  },
  entryLabel: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '10px'
  },
  result: {
    minWidth: 140,
    fontSize: '1.25rem',
    fontWeight: '700'
  },
  labelHeader: {
    fontSize: '1.1rem !important',
    fontWeight: 'bold',
    marginBottom: '5px',
    minHeight: '28px',
  }
}));
export default styles;
